var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"perms"},[_c('perm-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }